import { jsx as _jsx } from "react/jsx-runtime";
import './RewardProgress.pcss';
export const RewardProgress = (props) => {
    const { progress } = props;
    return (_jsx("div", { className: 'custom-reward-button-wrapper', "data-testid": 'reward-button-progress', children: _jsx("div", { className: 'reward-button__progress', "data-state": 'progress', children: _jsx("div", { className: 'reward-button__progress-bar', style: { width: `${progress}%` } }) }) }));
};
